const componentsFormAddressFormEn = {
  address: "Address",
  city: "City",
  cityPlaceholder: "Cityville",
  country: "Country",
  postalCode: "ZIP / Postal code",
  postalCodePlaceholder: "100-0001",
  stateProvince: "State/Province Code",
  streetAddressInput: "Street Address",
  streetAddressInputPlaceholder: "123 Main Street\nApartment 101",
  addStreetAddressLine2: "Add optional address line 2",
  streetAddressLine2Input: "Address line 2",
  streetAddressLine2InputPlaceholder: "Apartment, suite, etc. (optional)",
};

export default componentsFormAddressFormEn;
